import t from 'tcomb'

import { STATUS } from '../const'

export default t.enums(STATUS, 'Status')
